import React from 'react';
import NotificationIcon from './NotificationIcon';
import { useT } from '../LocaleContext';
import {
  ToastNotification,
  ToastMessage,
  ToastCloseButton,
  ToastIconWrap,
} from '../styles/NotificationStyles';

const NotificationToast = ({ show = true, type = 'success', message, onClose }) => {
  const t = useT();
  if (!message) {
    return null;
  }

  return (
    <ToastNotification show={show} type={type}>
      <ToastIconWrap type={type}>
        <NotificationIcon type={type} />
      </ToastIconWrap>
      <ToastMessage>{message}</ToastMessage>
      {onClose && (
        <ToastCloseButton type={type} onClick={onClose} aria-label={t('system.closeNotification')}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </ToastCloseButton>
      )}
    </ToastNotification>
  );
};

export default NotificationToast;
